import { useEffect, useRef, useState } from "react";
import { useLocation, Link } from "react-router-dom";

import "./register.css"

import logo from "../../assets/general_assets/Transparent logo.png";
import api from "../../services/api"

export default function Register(){

    const [firstName, setFirstName] = useState("")
    const [lastName, setLastName] = useState("")
    const [email, setEmail] = useState("")
    const [password, setPassword] = useState("")
    const [confPassword, setConfPassword] = useState("")
    const [errForm, setErrForm] = useState({})

    const location = useLocation()

    const signIn = useRef(null)
    const logIn = useRef(null)

    const validarFormulario = () => {
        const erros = {}

        if (firstName.length === 0) erros.firstName = "Deve ser inserido um nome";
        if (lastName.length === 0) erros.lastName = "Deve ser inserido pelo menos um sobrenome";
        if (password.length < 8) erros.password = "A senha deve ter pelo menos 8 caracteres";
        if (password !== confPassword) erros.confPassword = "As senhas não são iguais"
        if (!/\S+@\S+\.\S+/.test(email)) erros.email = "Email inválido ou já existente";

        setErrForm(erros);
        return Object.keys(erros).length === 0;
    }

    async function userRegister(e) {
        e.preventDefault();

        const data = {
            firstName,
            lastName,
            email,
            password,
        }

        if (!validarFormulario()) {
            alert("You have been inserted non valid data, try again...");
            return;
        }

        try {
            await api.post("/api/register", data, {
            });
            alert("Successfull user register!!")

        } catch (error) {
            alert("Something went wrong, try again...")

        }
        

    }

    useEffect(() => {
        if (location.pathname === "/register" && !(logIn?.current.classList.contains('nonPage'))) {
            logIn?.current.classList.add('nonPage')
            signIn?.current.classList.remove('nonPage');
            
        } 
    })

    return (

        <>
        
            <section className="register_screen">
                <img id="registerLogo1" src={logo}/>
                <img id="registerLogo2" src={logo}/>

                <div className="register_box">
                    <h2>Let's start it now!</h2>
                    <div className="sign_log_box">
                        <Link to="/register"><h3 ref={signIn} id="signInTab">Sign in</h3></Link>
                        <Link to="/login"><h3 ref={logIn} id="logInTab">Log in</h3></Link>
                    </div>
                    <form id="signIn" onSubmit={userRegister} className="register_form">
                        <input
                            placeholder="name"
                            type="text"
                            name="firstName"
                            value={firstName} 
                            required
                            onChange={e => setFirstName(e.target.value)}
                            />{errForm.firstName && <p className="error">{errForm.firstName}</p>}
                        <input
                            placeholder="last name" 
                            type="text"
                            name="lastName"
                            value={lastName} 
                            required
                            onChange={e => setLastName(e.target.value)}
                            />{errForm.lastName && <p className="error">{errForm.lastName}</p>}
                        <input
                            placeholder="email"
                            type="text"
                            name="email"
                            value={email} 
                            required
                            onChange={e => setEmail(e.target.value)}
                        />{errForm.email && <p className="error">{errForm.email}</p>}
                        <input 
                            placeholder="password"
                            type="password"
                            name="password"
                            value={password} 
                            required
                            onChange={e => setPassword(e.target.value)}
                            />{errForm.password && <p className="error">{errForm.password}</p>}
                        <input 
                            placeholder="confirm password"
                            type="password"
                            name="confPassword"
                            value={confPassword} 
                            required
                            onChange={e => setConfPassword(e.target.value)}
                        />{errForm.confPassword && <p className="error">{errForm.confPassword}</p>}
                    <button type="submit" className="register_button">
                        Sign in
                    </button>
                    </form>
                    <div className="terms">
                        <input id="termCheckbox" type="checkbox"/>
                        <label for="termCheckbox">Terms and Conditions</label>                            
                    </div>
                </div>

            </section>

        </>

    )


}